module.exports = __webpack_public_path__ + "static/media/validation-error.3c9679f3.svg";